// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const Spam = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      d="m15.623 6.254.001 5.487-3.879 3.882-5.487.001-3.882-3.879-.001-5.487 3.879-3.882 5.487-.001z"
    />
    <path stroke="currentColor" strokeLinecap="square" strokeLinejoin="round" d="M9 5.625v3.938" />
    <path fill="currentColor" d="M9 12.656a.562.562 0 1 0 0-1.125.562.562 0 0 0 0 1.125" />
  </svg>
);
const ForwardRef = forwardRef(Spam);
export default ForwardRef;
